__turbopack_context__.v({
  "dot": "UnKUiq_dot",
  "dotBounce": "UnKUiq_dotBounce",
  "dotWrapper": "UnKUiq_dotWrapper",
});
